var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
let InfosetsReborn = class InfosetsReborn extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
        this.tokenPollTimer = null;
        this.lastSentToken = '';
    }
    get iframeSrc() {
        return `${getRebornUrl()}/`;
    }
    /**
     * `COMPANY_INIT` é o tipo que o `useInfosetsPostMessage` do reborn escuta;
     * qualquer outro deixa o iframe em branco.
     *
     * `accountId`, `role` e `email` vão juntos porque o `/user/me` do reborn
     * responde 404 e o JWT só carrega o id do usuário — o que não for mandado
     * daqui vira acesso liberado lá.
     */
    sendInit() {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow)
            return;
        const token = localStorage.getItem('auth_token_default') || '';
        this.lastSentToken = token;
        // @ts-ignore TS2349: $auth injetado pelo vue-auth
        const user = this.$auth.user() || {};
        iframe.contentWindow.postMessage({
            type: 'COMPANY_INIT',
            token,
            accountId: user.account_id || '',
            role: user.role || '',
            email: user.email || '',
            features: Array.isArray(user.features) ? user.features : [],
        }, '*');
    }
    onIframeLoad() {
        this.stopSessionRecovery();
        this.sendInit();
        // Cobre a race entre o @load e o React estar pronto para receber.
        this.retryTimers.push(setTimeout(() => this.sendInit(), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit(), 2000));
    }
    /** Após SESSION_EXPIRED, reenvia o token assim que o login o renovar. */
    startSessionRecovery() {
        if (this.tokenPollTimer)
            return;
        this.sendInit();
        this.tokenPollTimer = setInterval(() => {
            const current = localStorage.getItem('auth_token_default') || '';
            if (current && current !== this.lastSentToken) {
                this.sendInit();
                this.stopSessionRecovery();
            }
        }, 500);
        // Teto de 10 min para o polling não vazar.
        this.retryTimers.push(setTimeout(() => this.stopSessionRecovery(), 10 * 60 * 1000));
    }
    stopSessionRecovery() {
        if (this.tokenPollTimer) {
            clearInterval(this.tokenPollTimer);
            this.tokenPollTimer = null;
        }
    }
    handleMessage(event) {
        if (!event.data)
            return;
        if (event.data.type === 'IFRAME_READY') {
            this.sendInit();
            return;
        }
        // O React detectou 401/403 e espera um token novo.
        if (event.data.type === 'SESSION_EXPIRED') {
            this.startSessionRecovery();
            return;
        }
        if (event.data.type === 'NAVIGATE_PARENT') {
            this.navigateFromIframe(event);
        }
    }
    /**
     * Abrir uma lista sai do iframe: a tela de campanha ainda não foi migrada e
     * um iframe cross-origin não mexe em `window.top.location`. O reborn manda o
     * nome da rota e o push passa pelos guards de sempre.
     *
     * Valida a origem porque qualquer iframe da página pode postar para cá.
     */
    navigateFromIframe(event) {
        if (event.origin !== getRebornUrl())
            return;
        const route = event.data.route;
        if (!route || !route.name)
            return;
        this.$router
            .push({
            name: route.name,
            params: route.params || {},
            query: route.query || {},
        })
            // Repetir a rota atual rejeita com NavigationDuplicated — não é erro.
            .catch(() => undefined);
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
        this.stopSessionRecovery();
        this.retryTimers.forEach(clearTimeout);
        this.retryTimers = [];
    }
};
InfosetsReborn = __decorate([
    Component({ name: 'InfosetsReborn' })
], InfosetsReborn);
export default InfosetsReborn;
